import { useLang } from "../App";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-ink/10 bg-ivory py-6" aria-hidden="true">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="font-serif text-2xl font-medium italic text-ink/50 md:text-3xl">{item}</span>
                <span className="mx-10 h-1 w-1 rotate-45 bg-bronze/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
